import { ExpensePaymentOptionEnum } from "@finway-group/shared/lib/models/expense/expensePaymentOption.enum"
import { Col, Form, Radio, Row } from "antd"
import { type RadioChangeEvent } from "antd/lib/radio"
import React from "react"
import { useTranslation } from "react-i18next"
import { useExpenseFormContext } from "~Components/modals/expenseCreateForm.context"

export const PaymentOptionSelector = () => {
    const [{ expense, updateExpense }] = useExpenseFormContext()
    const { t } = useTranslation()

    const radioInputs = [
        { value: ExpensePaymentOptionEnum.BANK_TRANSFER, label: t("label:bank_transfer") },
        { value: ExpensePaymentOptionEnum.SMART_CARD, label: t("label:cards.virtual_card") },
    ]

    const onPaymentOptionChange = ({ target: { value } }: RadioChangeEvent) => {
        updateExpense({
            paymentOption: value,
            // when we switch to a card expense, we gotta unset the payment status
            ...(value === ExpensePaymentOptionEnum.SMART_CARD ? { paymentFlowInformation: undefined } : {}),
        })
    }

    return (
        <Row gutter={[16, 16]} align="middle">
            <Col span={24}>
                <Form.Item className="max-w-400" label={t("input:request.payment_option")}>
                    <div className="card-modal">
                        <Radio.Group value={expense?.paymentOption} onChange={onPaymentOptionChange} name="paymentOption">
                            {radioInputs.map(({ value, label }, index) => (
                                <Radio.Button key={index} value={value}>
                                    <p className="truncate">{label}</p>
                                </Radio.Button>
                            ))}
                        </Radio.Group>
                    </div>
                </Form.Item>
            </Col>
        </Row>
    )
}
